import React from "react";
import { Box } from "@mui/material";
import { ColorSystemProps } from "../../../constants";
import { ClickEventType } from "../../../types";
import { customEvent } from "../../../utils";
import { ColorIcon } from "../../common/Icons";

export function ETypeCTA({
  title,
  subtitle,
  href,
  buttonText = " 견적 받기",
  mainColor,
  bgColor,
  event,
}: {
  title: string;
  subtitle?: string;
  href: string;
  buttonText?: string;
  mainColor: ColorSystemProps;
  bgColor?: string;
  event?: ClickEventType;
}) {
  return (
    <Box style={{ padding: "0 20px 48px" }}>
      <Box
        style={{
          background: bgColor ?? mainColor.c100,
          border: `1px solid ${bgColor ? "#e9e9e9" : mainColor.c200}`,
          borderRadius: "16px",
          padding: "28px 24px",
          textAlign: "center",
        }}
      >
        <Box style={{ fontSize: "16px", fontWeight: 700, color: "#252525" }}>
          {title}
        </Box>
        {subtitle && (
          <Box style={{ fontSize: "14px", color: "#686868", marginTop: "8px" }}>
            {subtitle}
          </Box>
        )}
        <Box
          component="a"
          href={href}
          onClick={event ? () => customEvent(event) : undefined}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            marginTop: "20px",
            padding: "16px 32px",
            borderRadius: "12px",
            fontSize: "16px",
            fontWeight: 700,
            background: mainColor.c400,
            color: "#fff",
            textDecoration: "none",
          }}
        >
          <span>{buttonText}</span>
          <ColorIcon name="arrow_right_small" color="#fff" size={18} />
        </Box>
      </Box>
    </Box>
  );
}
